import React, { createContext, useContext, useReducer } from 'react';

import { IDataSource } from '../../../base/types';

interface IDataSourceStore {
    dataSource?: IDataSource
}

type ActionType = { type: 'SET_DATA_SOURCE'; payload?: IDataSource };

const dataSourceReducer = (state: IDataSourceStore, action: ActionType): IDataSourceStore => {
    switch (action.type) {
        case 'SET_DATA_SOURCE':
            return { ...state, dataSource: action.payload };
        default:
            return state;
    }
};

interface DataSourceContextProps {
    dataSource?: IDataSource,
    setDataSource: (dataSource?: IDataSource) => void
}

const DataSourceContext = createContext<DataSourceContextProps>({
    setDataSource: () => { }
});

export const DataSourceProvider = ({ dataSource: initialDataSource, children }: {
    dataSource?: IDataSource,
    children?: React.ReactNode
}) => {
    const [dataSource, dispatch] = useReducer(dataSourceReducer, { dataSource: initialDataSource });

    const setDataSource = (dataSource?: IDataSource) => {
        dispatch({ type: "SET_DATA_SOURCE", payload: dataSource })
    }

    return (
        <DataSourceContext.Provider value={{ ...dataSource, setDataSource }}>
            {children}
        </DataSourceContext.Provider>
    );
};

export function useDataSource() {
    return useContext(DataSourceContext);
}
